const enabledValues = ['true', '1', 'yes'];

const isEnabled = (value, fallback = false) => {
  if (value === undefined) return fallback;
  return enabledValues.includes(String(value).toLowerCase());
};

export const ENABLE_VIDEO_NOTES = isEnabled(process.env.VUE_APP_ENABLE_VIDEO_NOTES, false);
export const ENABLE_VIDEO_POLLS = isEnabled(process.env.VUE_APP_ENABLE_VIDEO_POLLS, false);
